/* eslint-disable @typescript-eslint/no-magic-numbers */
import { AgentData } from '../types/practice-types';

/* Backend-defined online status codes that should be treated as "online" in the UI.
   These values come from the upstream system's status enumeration; changing them
   without coordinating with the backend may cause agents to be misclassified. */
const ONLINE_STATUS_CODES: ReadonlyArray<AgentData['online']> = [1, 2, 11, 12];

export const isAgentOnline = (agent: AgentData): boolean =>
  ONLINE_STATUS_CODES.includes(agent.online);

export const isServerAgent = (agent: AgentData): boolean => agent.type === 'Server';
